import apiClient from './apiClient';

export async function uploadPreview(importType, file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await apiClient.post(`/imports/${importType}/preview`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}

export async function commitImport(importId) {
  const res = await apiClient.post(`/imports/${importId}/commit`);
  return res.data.data;
}

export async function rollbackImport(importId) {
  const res = await apiClient.post(`/imports/${importId}/rollback`);
  return res.data.data;
}

export async function getImportHistory(type) {
  const res = await apiClient.get('/imports/history', { params: { type } });
  return res.data.data.items;
}

export async function getImportErrors(importId) {
  const res = await apiClient.get(`/imports/${importId}/errors`);
  return res.data.data.items;
}

export async function purgeData(type, fromDate, toDate) {
  const res = await apiClient.post('/imports/purge', { type, fromDate, toDate });
  return res.data.data;
}
